<script setup lang="ts">
import type { ComboboxLabelProps } from "reka-ui";
import { ComboboxLabel, useForwardProps } from "reka-ui";

const props = defineProps<ComboboxLabelProps>();
const forwardedProps = useForwardProps(props);
</script>

<template>
  <ComboboxLabel
    v-bind="forwardedProps"
    class="px-2 py-1 text-xs font-medium text-slate-500 select-none"
  >
    <slot />
  </ComboboxLabel>
</template>
